import { render, staticRenderFns } from "./SelectShop.vue?vue&type=template&id=4e4a9c16"
import script from "./SelectShop.vue?vue&type=script&lang=js"
export * from "./SelectShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports